<template>
  <splash/>
  <div class="container mt-4" dir="rtl">
    <sidebar/>
    <div class="card-panel-main col-lg-9 mb-5 p-4" style="transform: translateX(-19vw)">

    <div class="card bg-white">
      <div class="p-2" dir="ltr">
        <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
      </div>
      <div class="d-flex m-3 justify-content-between">
        <p class="fw-bold">
          تعریف پیامد فوری/ {{$route.params.title}}
        </p>
        <div>
          <div class="d-flex changer">
            <p>
              پیامد فوری
            </p>
            <router-link :to="`/Financial_management_and_productivity/IntermediateOutcome/by/${id_route}/${$route.params.title}`">
              پیامد میانی
            </router-link>
          </div>
        </div>
      </div>
     <center> <hr style="width: 90%;"></center>
      <wealth/>


    </div>

    </div>
  </div>
</template>
<script  >
import Splash from "@/components/Splash/Splash.vue";
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import financial_information from "@/components/Financial_management_and_productivity/basic/financial_information.vue";
import Received_information from "@/components/Financial_management_and_productivity/basic/Received_information.vue";
import Outcome_information from "@/components/Financial_management_and_productivity/basic/Outcome_information.vue";
import wealth from "@/components/Financial_management_and_productivity/mother/DefinitionOfConsequence/wealth.vue";
import debts from "@/components/Financial_management_and_productivity/DefinitionOfConsequence/debts.vue";
import router from "@/router";

export  default {
  components: {wealth, Outcome_information, Received_information, Sidebar, Splash,financial_information, debts},
  data(){
    return{
      id_route: this.$route['params']['id'],

    }
  },
  methods:{
    checkIsMother(){
      if (this.is_mother){
        router.push('/pishkhan')
      }

    }
  },
  mounted() {
    this.checkIsMother()
  }


}

</script>

<style scoped lang="scss">
.changer{
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 15vw;
  justify-content: space-evenly;
  &>p:nth-child(1){
    width: 8vw;
    height: 2vw;
    background-color: #3742FA;
    color: #fff;
    transform: translateX(.4vw);
    border-radius: 1vw;
  }
  &>p:nth-child(2){
    margin-left: 1vw;
  }  &>p {
   cursor: pointer;
  font-size: 1vw;
  }
  &>a{
    color: black;
    text-decoration: none;
    margin-left: .9vw;
  }
}
p {
  font-size: 1vw;
}
</style>